import POSSelectorButton from '../../../Buttons/POSSelectorButton';

interface Props {
  selectedCategoryName?: string;

  disabled?: boolean;

  onClick: () => void;
}

const POSCategoryFilterCard = ({
  selectedCategoryName,
  disabled,
  onClick,
}: Props) => {
  return (
    <POSSelectorButton
      label="Categoría"
      value={selectedCategoryName || 'Todas las categorías'}
      selected={!!selectedCategoryName}
      disabled={disabled}
      onClick={onClick}
    />
  );
};

export default POSCategoryFilterCard;
